import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { CenteredDivTitle } from '../../common/components/CenteredPageTitle.styles';
import CenteredPageTitle from '../../common/components/CenteredPageTitle';
import {
  AiChatBox, AiProductsFormStyles, AiSidebarScroll, SidebarCard,
} from './AiProducts.styles';
import StorageService from '../../services/StorageService';
import AiMessage from './components/AiMessage';
import HumanMessage from './components/HumanMessage';
import NoMessagePlaceHolder from './components/NoMessagePlaceHolder';
import TextInputAi from './components/TextInputAi';
import { Label } from '../../common/formInputs/styles/common';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import { generalAlertError } from '../../common/utils/alerts';
import AnimatedStatus from './components/AnimatedStatus';
import DocumentUploadComponent from './components/DocumentUploadComponent';
import ProductAttachments from './components/ProductAttachments';

const Storage = new StorageService();
function AiProducts({ showTitle = true, placeholderMessage }) {
  const chatBoxRef = useRef(null);
  const user = Storage.getUser();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [dataRequired, setdataRequired] = useState([]);
  const [client, setClient] = useState(null);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [collectsClientData, setCollectsClientData] = useState(true);

  const sendMessage = async () => {
    if (message === null) {
      generalAlertError('Per inviare un messaggio devi scrivere qualcosa');
      return;
    }
    setMessages((prevMessages) => [...prevMessages, message]);
    const data = {
      message: message.message,
    };
    setMessage(null);
    setLoading(true);
    const endpoint = threadId === null ? 'ai/product-agent' : `ai/product-agent/${threadId}`;
    const response = await managementAxe.post(endpoint, data);

    if (response.status !== 200) {
      generalAlertError('Si è verificato un errore durante l\'invio del messaggio');
      setLoading(false);
      return;
    }

    const aiMessage = {
      message: response.data.response.message,
      type: 'ai',
      created_at: new Date(),
    };
    setThreadId(response.data.threadId);
    setMessages((prevMessages) => [...prevMessages, aiMessage]);

    if (documents.length === 0 && response.data.response.product) {
      setDocuments(response.data.response.product.documents);
    }

    if (dataRequired.length === 0 && response.data.response.product) {
      setdataRequired(response.data.response.product.data);
    }
    if (attachments.length === 0 && response.data.response.product?.attachments) {
      setAttachments(response.data.response.product.attachments);
    }
    if (client === null && response.data.response.client) {
      setClient(response.data.response.client);
    }
    if (response.data.response.product) {
      setCollectsClientData(response.data.response.product.collects_client_data !== false);
    }
    setLoading(false);
  };

  const selectSuggestion = (text) => setMessage({
    message: text,
    type: 'human',
    created_at: new Date(),
  });

  useEffect(() => {
    // Scroll only the chat box itself (not scrollIntoView, which can also
    // drag the whole page down to reveal it) and only once there's actually
    // something to scroll to, so mounting this widget with no messages yet
    // (e.g. when a product search comes up empty) doesn't nudge the page.
    if (chatBoxRef.current && (messages.length > 0 || loading)) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages, loading]);

  return (
    <AiProductsFormStyles>
      {showTitle && (
        <CenteredDivTitle className="d-flex align-items-center justify-content-center gap-3">
          <CenteredPageTitle title="Chat Prodotti AI" />
        </CenteredDivTitle>
      )}
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-7 col-xl-9 h-100">
          <AiChatBox ref={chatBoxRef} className="border border-1 rounded-3 shadow-sm p-2">
            <div className="w-100 mt-auto">
              {messages.length === 0 ? (
                <NoMessagePlaceHolder
                  message={placeholderMessage}
                  onSuggestionSelect={selectSuggestion}
                />
              ) : (
                messages.map((msg, index) => {
                  if (msg.type === 'ai') {
                    // eslint-disable-next-line react/no-array-index-key
                    return <AiMessage key={index} message={msg} />;
                  }
                  // eslint-disable-next-line react/no-array-index-key
                  return <HumanMessage message={msg} key={index} user={user} />;
                })
              )}
              {loading && (
                <AnimatedStatus />
              )}
            </div>
          </AiChatBox>
          <div className="mt-4 mx-auto">
            <div className="row">
              {documents.length > 0 && (
                <div className="col-12 mb-3">
                  <div className="row">
                    {documents.map((document, index) => (
                      <DocumentUploadComponent
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        document={document}
                        threadId={threadId}
                        setUploadedDocuments={setUploadedDocuments}
                        uploadedDocuments={uploadedDocuments}
                      />
                    ))}
                  </div>
                </div>
              )}
              <div className="col-12 mb-2">
                <Label>Domanda l&apos;IA per il prodotto che hai neccessita.</Label>
              </div>
              <div className="col-12">
                <TextInputAi
                  placeholder="Esempio: Vorrei un preventivo per la casa del cliente Mario Rossi maschio nato il 17 aggosto 1990"
                  rows={3}
                  className="form-control"
                  name="aiQuestion"
                  id="aiQuestion"
                  value={message ? message.message : ''}
                  onChange={(e) => setMessage({
                    message: e.target.value,
                    type: 'human',
                    created_at: new Date(),
                  })}
                />
              </div>
              <div className="col-12 mt-2">
                <button type="button" onClick={() => sendMessage()} className="btn btn-success rounded-pill h-100 w-100 d-flex align-items-center justify-content-center gap-2 py-2">
                  <p className="m-0 fw-bold fs-6">Invia</p>
                  <FontAwesomeIcon icon={faPaperPlane} size="lg" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-5 col-xl-3 h-100">
          <div className="p-0">
            <AiSidebarScroll className="px-1">
              <div className="row">
                <ProductAttachments attachments={attachments} />
                <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                  <SidebarCard>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6 className="m-0 fw-bold sidebar-title">Documenti Richiesti</h6>
                      {documents.length > 0 && (
                        <span className="badge rounded-pill sidebar-count">{documents.length}</span>
                      )}
                    </div>
                    <ul className="list-unstyled m-0 d-grid gap-2">
                      {documents.map((document, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index} className="sidebar-item">
                          {document.name}
                        </li>
                      ))}
                      {documents.length === 0 && (
                        <li className="sidebar-empty">
                          Inizia la conversazione per vedere i documenti richiesti
                        </li>
                      )}
                    </ul>
                  </SidebarCard>
                </div>
                {collectsClientData && (
                  <>
                    <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                      <SidebarCard>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6 className="m-0 fw-bold sidebar-title">Dati Richiesti</h6>
                          {dataRequired.length > 0 && (
                            <span className="badge rounded-pill sidebar-count">{dataRequired.length}</span>
                          )}
                        </div>
                        <ul className="list-unstyled m-0 d-grid gap-2">
                          {dataRequired.map((data, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <li key={index} className="sidebar-item">
                              {data.name}
                            </li>
                          ))}
                          {dataRequired.length === 0 && (
                            <li className="sidebar-empty">
                              Inizia la conversazione per vedere i dati richiesti
                            </li>
                          )}
                        </ul>
                      </SidebarCard>
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                      <SidebarCard>
                        <h6 className="m-0 mb-2 fw-bold sidebar-title">Informazioni Cliente</h6>
                        <ul className="list-unstyled m-0 d-grid gap-2">
                          {client !== null && (
                            <>
                              <li className="sidebar-item">
                                {client.name ? `${client.name} ${client.surname}` : client.bussines_name}
                              </li>
                              {client.birth_date && (
                                <li className="sidebar-item">
                                  {`Nato il ${client.birth_date}`}
                                </li>
                              )}
                            </>
                          )}
                          {client === null && (
                            <li className="sidebar-empty">
                              Inizia la conversazione per vedere i dati cliente
                            </li>
                          )}
                        </ul>
                      </SidebarCard>
                    </div>
                  </>
                )}
              </div>
            </AiSidebarScroll>
          </div>
        </div>
      </div>
    </AiProductsFormStyles>
  );
}

export default AiProducts;
